import { render, staticRenderFns } from "./CongrateFinishFormation.vue?vue&type=template&id=304f765c&scoped=true&"
import script from "./CongrateFinishFormation.vue?vue&type=script&lang=js&"
export * from "./CongrateFinishFormation.vue?vue&type=script&lang=js&"
import style0 from "./CongrateFinishFormation.vue?vue&type=style&index=0&id=304f765c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f765c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
